import { render, staticRenderFns } from "./NewSection.vue?vue&type=template&id=4391f3d4&"
import script from "./NewSection.vue?vue&type=script&lang=js&"
export * from "./NewSection.vue?vue&type=script&lang=js&"
import style0 from "./NewSection.vue?vue&type=style&index=0&id=4391f3d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports